import makeStyles from "@material-ui/core/styles/makeStyles";
import pageContainer from "../../styles/pageContainer";

export const useStyles = makeStyles(theme => ({
  viewPortCenter: {
    position: "absolute",
    top: "50vh",
    left: "50vw"
  },
  pageContainer: {
    ...pageContainer(theme)
  }
}));
